import { formatNumberForLocale } from '@/utils/numberFormatting'

export const DISCOUNT_ENTRY_MODE = {
  AMOUNT: 'AMOUNT',
  PERCENTAGE: 'PERCENTAGE'
}

const toNumber = (value) => {
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

const roundCurrency = (value) =>
  Math.round((value + Number.EPSILON) * 100) / 100

const roundPercentage = (value) =>
  Math.round((value + Number.EPSILON) * 10000) / 10000

export const amountOffFromDiscountPercentage = (
  cartonPrice,
  discountPercentage
) => {
  const price = toNumber(cartonPrice)
  const percentage = toNumber(discountPercentage)
  if (price == null || percentage == null) return null

  return roundCurrency(price * (percentage / 100))
}

export const discountPercentageFromAmountOff = (cartonPrice, amountOff) => {
  const price = toNumber(cartonPrice)
  const amount = toNumber(amountOff)
  if (price == null || price <= 0 || amount == null) return null

  return roundPercentage((amount / price) * 100)
}

export const formatDiscountPercentage = (value, locale) => {
  const percentage = toNumber(value)
  if (percentage == null) return null

  return formatNumberForLocale(
    percentage,
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    locale
  )
}

export const setDiscountPercentageFromAmountOff = (
  target,
  cartonPrice,
  amountOff
) => {
  const discountPercentage = discountPercentageFromAmountOff(
    cartonPrice,
    amountOff
  )
  if (discountPercentage == null) {
    delete target.discountPercentage
    return
  }

  target.discountPercentage = discountPercentage
}
